export enum SeatGroupDisplayMode {
  None = 0,
  Together = 1,
  Separately = 2,
}
